import * as React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import {FBRepeater} from "./FBRepeater";
import {FBColumn} from "FormBuilder/Core/FBColumn";
import {FBRowOptions} from "FormBuilder/Core/FBRow.Options";
import {RefArray} from "shared/utilities/react/RefArray";
import {FBRow} from "FormBuilder/Core/FBRow";
import {SingleEvent} from "shared/utilities/Events/SingleEvent";
import {FBFieldBase, FBFieldBaseProps, FBFieldBaseState} from "FormBuilder/Fields/Core/FBFieldBase";
import {PublishOnceEvent} from "shared/utilities/Events/PublishOnceEvent";
import {PriceManager} from "FormBuilder/Utilities/Managers/PriceManager/PriceManager";
import {FBFieldBaseOptions, FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {GroupCalculator} from "FormBuilder/Core/Calulators/GroupCalculator";
import {
    FBFieldWithPriceBase,
    FBFieldWithPriceBaseProps,
    FBFieldWithPriceBaseState
} from "FormBuilder/Fields/Core/FBFieldWithPriceBase";
import {CalculatorBase} from "FormBuilder/Core/Calulators/CalculatorBase";
import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";
import {FBRepeaterItemModel} from "./FBRepeaterItem.Model";
import {ContainerDataRetriever} from "FormBuilder/Core/FormBuilder.Model";
import {FBRowModel} from "FormBuilder/Core/FBRow.Model";
import {FBFieldBaseModel} from "FormBuilder/Fields/Core/FBFieldBase.Model";
import {EventManager} from "shared/utilities/Events/EventManager";
import {GetModel} from "FormBuilder/Events/GetModel";
import {FBRepeaterModel} from "./FBRepeater.Model";
import {FBRepeaterOptions} from "./FBRepeater.Options";
import {GetFieldOptions} from "FormBuilder/Events/GetFieldOptions";
import {GetField} from "FormBuilder/Events/GetField";
import {FBRepeaterItemOptions} from "./FBRepeaterItem.Options";
import {GroupOnCreateRow} from "FormBuilder/Events/GroupOnCreateRow";

export class FBRepeaterItem extends FBFieldWithPriceBase<FBRepeaterItemProps, {}>{

    static defaultProps: Partial<FBRepeaterItemProps> = {
    };



    public get RowOptions(): FBRowModel[]{
        return this.props.Item.GetRows();
    }

    constructor(props: FBRepeaterItemProps) {
        super(props);


    }

    public GetPreviousData(){
        let previousData=this.FormBuilder.PreviousData;
        if(previousData==null||previousData.Fields==null)
            return null;
        return previousData.Fields.find(x=>x.Id==this.props.Model.Options.Id);
    }
    public GetPreviousDataProperty(propertyName:string,defaultValue:any)
    {
        let previousData=this.GetPreviousData();
        if(previousData==null||previousData[propertyName]==null)
            return defaultValue;

        return previousData[propertyName];
    }

    public get PreviousData(){
        return {Fields:this.GetPreviousDataProperty('Value',[])};
    }
    public SubRender() {
        return (
            <div className={'rnRepeaterItem'} key={this.props.Model.Options.Id}>

                {EventManager.SubscriptionCount(GroupOnCreateRow)>0?
                    EventManager.Publish(new GroupOnCreateRow(()=>
                        this.Model.Rows.map((x,index)=>
                            this.CreateRow(x,index)
                        )))

                    :this.Model.Rows.map((x,index)=>
                        this.CreateRow(x,index)
                    )
                }

                <div style={{marginTop:2}}>
                    <button style={{marginRight:5}} className={'rnbtn rnbtn-light'} title={'Remove'} onClick={(e) =>{e.preventDefault(); this.Model.OnRemove.Publish(this.Model)}} >
                        <FontAwesomeIcon icon={faTrashAlt}/>
                    </button>
                    {this.Model.ShowAddButton &&
                    <button   className={'rnbtn rnbtn-light'} title={'Add'} onClick={(e) =>{e.preventDefault(); this.Model.OnAdd.Publish()}}>
                        <FontAwesomeIcon icon={faPlus}/>
                    </button>
                    }

                </div>
            </div>
        )
    }


    public CreateRow(model:FBRowModel,index:number)
    {
        return this.props.Model.FormBuilder.CreateSubRow(model);
    }

    CreateSubRow(options: FBRowModel) {
        return this.FormBuilder.CreateSubRow(options);
    }

    DeleteField(field: FBFieldBaseModel) {
        alert('delete');
    }

    GetFieldById(id: any): FBFieldBaseModel {
        return undefined;
    }

    public GetValue() {
        let values:any[]=[];
        for(let field of this.GetFields())
        {
            values.push(field.SerializeEntry());
        }

        return values;
    }

    GetFields(): FBFieldBaseModel[] {
        return this.Model.GetFields();
    }

    GetNextFieldId(): number {
        return this.FormBuilder.GetNextFieldId();
    }

    GetProductPrice(): any {
        return this.FormBuilder.GetProductPrice();
    }

    GetRowByFieldId(fieldId: number): FBRowModel {
        return this.FormBuilder.GetRowByFieldId(fieldId);
    }

    GetRows(): FBRowModel[] {
        return this.Model.Rows;
    }

    GetRuler(): any {
        return this.FormBuilder.GetRuler();
    }

    GetSalePrice(): any {
        return this.FormBuilder.GetSalePrice();
    }

    GetVariationValue(VariationName: string) {
        return this.FormBuilder.GetVariationValue(VariationName);
    }

    Refresh():Promise<void> {
        return new Promise(resolve =>this.forceUpdate(resolve) );

    }

    public get FormBuilder():ContainerDataRetriever{
        return this.props.Model.FormBuilder;
    }

    GetStoresInformation(): boolean {
        return true;
    }


}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FBRepeaterItemProps extends FBFieldWithPriceBaseProps{
    Item:FBRepeaterItemModel;
    OnRemoveItem:()=>void;
    OnAddItem:()=>void;
    Model:FBRepeaterItemModel;
}

interface FBRepeaterItemState extends FBFieldWithPriceBaseState{

}

//#endregion "My Region"